import { Injectable, EventEmitter, Output } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Consulta } from 'src/app/models/consulta';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class CiacService {

  dadosFormulario: any = new EventEmitter();
  dadosFormDCE: any = new EventEmitter();

  constructor(private httpClient: HttpClient) { }

  // Consultas
  getListaConsultas(params) {
    return this.httpClient.post<any>(environment.wsUrl + 'admin/consulta/list', params, {}).toPromise();
  }

  getConsultasCredito() {
    return this.httpClient.get(environment.wsUrl + 'admin/consulta/listarConsultasCredito').toPromise();
  }

  getListaConsultasCredito(params) {
    return this.httpClient.post<any>(environment.wsUrl + 'admin/consulta/list/credito', params, {}).toPromise();
  }

  addConsultaCiac(form) {
    return this.httpClient.post<any>(environment.wsUrl + 'admin/consulta/insert', form, {}).toPromise();
  }

  editConsultaCiac(id) {
    return this.httpClient.get(environment.wsUrl + 'admin/consulta/get/' + id).toPromise();
  }

  listDadosConsultaSaida(id) {
    return this.httpClient.get<any>(environment.wsUrl + 'admin/dadosConsultaSaida/listporconsultafornecedor/' + id).toPromise();
  }

  updateConsultaCiac(form) {
    return this.httpClient.post<any>(environment.wsUrl + 'admin/consulta/update', form, {}).toPromise();
  }

  delConsultaCiac(justificativa, id, ignore = []) {
    return this.httpClient.post<any>(environment.wsUrl + 'admin/consulta/delete', id, {
      headers: {
        ignore: ignore,
        justificativa: justificativa
      }
    }).toPromise();
  }
  // Fim Consultas

  // Tipo Consultas
  getListaTipoConsultas() {
    return this.httpClient.get<any>(environment.wsUrl + 'consulta/tipoconsultas').toPromise();
  }

  getTipoConsultaCredito() {
    return this.httpClient.get<any>(environment.wsUrl + 'admin/dadosConsultaSaida/tipocamposdcs').toPromise();
  }
  // Fim Tipo Consultas

  // Dados Saída
  getDadosSaida(id) {
    return this.httpClient.get(environment.wsUrl + 'admin/consulta/get/' + id).toPromise();
  }

  getDcsConsulta(params) {
    return this.httpClient.post<any>(environment.wsUrl + 'admin/dadosConsultaSaida/listporconsulta', params).toPromise();
  }

  getTiposCampo() {
    return this.httpClient.get(environment.wsUrl + 'admin/dadosConsultaSaida/tipocamposdcs').toPromise();
  }

  addDadosSaida(form) {
    return this.httpClient.post<any>(environment.wsUrl + 'admin/dadosConsultaSaida/insertOrUpdate', form, {}).toPromise();
  }

  getHistoricoDadosSaida(id) {
    let retorno = this.httpClient.get(environment.wsUrl + 'admin/dadosConsultaSaida/get/' + id).toPromise();
    let dados;
    retorno.then(c => {
      dados = {
        id: c['id'],
        idDadosConsultaSaidaPai: c['idDadosConsultaSaidaPai'] ? c['idDadosConsultaSaidaPai'] : null,
        nome: c['nome'],
        idTipoConsulta: c['idTipo'],
        descricao: c['descricao'],
        caminho: c['caminho'],
        visibilidade: c['visibilidade'],
        idConsulta: c['idConsulta'],
      }
      this.dadosFormulario.emit(dados);
    });
  }

  delDadosSaida(justificativa, id, ignore = []) {
    return this.httpClient.post<any>(environment.wsUrl + 'admin/dadosConsultaSaida/delete', id, {
      headers: {
        ignore: ignore,
        justificativa: justificativa
      }
    }).toPromise();
  }
  // Fim dados Saída

  // Fornecedores
  getListaFornecedores(filter) {
    return this.httpClient.post<any>(environment.wsUrl + 'admin/fornecedor/list', filter, {}).toPromise();
  }

  getFornecedor(id) {
    return this.httpClient.get<any>(environment.wsUrl + 'admin/fornecedor/get/' + id).toPromise();
  }

  addFornecedorCiac(form) {
    return this.httpClient.post<any>(environment.wsUrl + 'admin/fornecedor/insert', form, {}).toPromise();
  }

  updateFornecedorCiac(form) {
    return this.httpClient.post<any>(environment.wsUrl + 'admin/fornecedor/update', form, {}).toPromise();
  }

  delFornecedorCiac(justificativa, id, ignore = []) {
    return this.httpClient.post<any>(environment.wsUrl + 'admin/fornecedor/delete', id, {
      headers: {
        ignore: ignore,
        justificativa: justificativa
      }
    }).toPromise();
  }
  // Fim Fornecedores

  // Fornecedores/Consulta
  getListaFornecedoresConsultas(filter) {
    return this.httpClient.post<any>(environment.wsUrl + 'admin/consultaFornecedor/list', filter, {}).toPromise();
  }

  getListaTipoRequisicao() {
    return this.httpClient.get(environment.wsUrl + 'admin/consultaFornecedor/tiposrequisicao').toPromise();
  }

  getListaTipoParametros() {
    return this.httpClient.get(environment.wsUrl + 'admin/consultaFornecedor/tiposenvioparametro').toPromise();
  }

  getCampoPesquisa() {
    return this.httpClient.get(environment.wsUrl + 'admin/consultaFornecedor/campospesquisa').toPromise();
  }

  getConsultaFornecedor(id) {
    return this.httpClient.get(environment.wsUrl + 'admin/consultaFornecedor/get/' + id).toPromise();
  }

  addConsultaFornecedor(params) {
    return this.httpClient.post<any>(environment.wsUrl + 'admin/consultaFornecedor/insertOrUpdate', params, {}).toPromise();
  }

  editConsultaFornecedor(params) {
    return this.httpClient.post<any>(environment.wsUrl + 'admin/consultaFornecedor/insertOrUpdate', params, {}).toPromise();
  }

  delConsultaFornecedor(justificativa, id, ignore = []) {
    return this.httpClient.post<any>(environment.wsUrl + 'admin/consultaFornecedor/delete', id, {
      headers: {
        ignore: ignore,
        justificativa: justificativa
      }
    }).toPromise();
  }
  // Fim Fornecedores / Consulta

  // Inicio Conversao
  getListaConversao(filter) {
    return this.httpClient.post<any>(environment.wsUrl + 'admin/conversao/list', filter, {}).toPromise();
  }

  getConversao(id) {
    return this.httpClient.get(environment.wsUrl + 'admin/conversao/get/' + id).toPromise();
  }

  addConversao(params) {
    return this.httpClient.post<any>(environment.wsUrl + 'admin/conversao/insertOrUpdate', params, {}).toPromise();
  }

  editConversao(params) {
    return this.httpClient.post<any>(environment.wsUrl + 'admin/conversao/insertOrUpdate', params, {}).toPromise();
  }

  delConversao(justificativa, id, ignore = []) {
    return this.httpClient.post<any>(environment.wsUrl + 'admin/conversao/delete', id, {
      headers: {
        ignore: ignore,
        justificativa: justificativa
      }
    }).toPromise();
  }
  // Fim conversões

  // Dados Entrada
  getDadosEntrada(params) {
    return this.httpClient.post<any>(environment.wsUrl + 'admin/dadosConsultaEntrada/listporconsultafornecedor', params, {}).toPromise();
  }

  getDadosConsultaEntrada(id) {
    let retorno = this.httpClient.get<any>(environment.wsUrl + 'admin/dadosConsultaEntrada/get/' + id).toPromise();
    let dados;
    retorno.then(c => {
      dados = {
        id: c['id'],
        idDadoConsultaSaida: c['idDadoConsultaSaida'] ? c['idDadoConsultaSaida'] : null,
        idTipoConsulta: c['idTipoCampoConsulta'],
        idConversao: c['idConversao'] ? c['idConversao'] : null,
        idDadosConsultaEntradaPai: c['idDadosConsultaEntradaPai'] ? c['idDadosConsultaEntradaPai'] : null,
        nome: c['nome'] ? c['nome'] : '',
        formatoEntrada: c['formatoEntrada'] ? c['formatoEntrada'] : '',
        formatoSaida: c['formatoSaida'] ? c['formatoSaida'] : '',
        regex: c['regex'] ? c['regex'] : '',
        caminho: c['caminho'] ? c['caminho'] : '',
        valorPadrao: c['valorPadrao'] ? c['valorPadrao'] : '',
        descricao: c['descricao'] ? c['descricao'] : ''
      }
      this.dadosFormDCE.emit(dados);
    });
  }

  addDadosEntrada(params) {
    return this.httpClient.post<any>(environment.wsUrl + 'admin/dadosConsultaEntrada/insertOrUpdate', params, {}).toPromise();
  }

  delDadosEntrada(justificativa, id, ignore = []) {
    return this.httpClient.post<any>(environment.wsUrl + 'admin/dadosConsultaEntrada/delete', id, {
      headers: {
        ignore: ignore,
        justificativa: justificativa
      }
    }).toPromise();
  }
  // Fim dados entrada

  getListaTipoDadosSaida(id) {
    return this.httpClient.get<any>(environment.wsUrl + 'admin/dadosConsultaSaida/listporconsulta/' + id).toPromise();
  }

  getListaTipoDadosEntrada(id) {
    return this.httpClient.get<any>(environment.wsUrl + 'admin/dadosConsultaEntrada/listporidconsultafornecedor/' + id).toPromise();
  }

  // Busca as consultas de crédito sem insumos para exibir no ADD e EDIT de unidades ....
  getListaConsultaCreditoSemInsumos() {
    return this.httpClient.get<any>(environment.wsUrl + 'admin/consulta/listarConsultasCreditoSemInsumos').toPromise();
  }

  getListaInsumosConsultas() {
    return this.httpClient.get<any>(environment.wsUrl + 'admin/consulta/listarInsumos').toPromise();
  }

  getConsultaCreditoLaudo() {
    return this.httpClient.get<Consulta[]>(environment.wsUrl + 'admin/consulta/listarConsultasCreditoSemInsumos').pipe(
      map(r => r.map(c => new Consulta(c)))).toPromise();
  }

}
